import { Box, ColorOptions, convertHexToRGBA, Spacer, Text, TextInput } from '@jfs/ui-new'
import { useEffect, useRef, useState } from 'react'
import { TextInput as RNTextInput } from 'react-native'
import { Colors } from '../../util/util'
import { SvgImage } from '../SvgImage'

export const TextInputWithLabelOnBorder = ({
  setFieldValue,
  fieldName,
  label,
  leftComponent,
  rightComponent,
  maxLength,
  touched,
  error,
  innerRef,
  onFocus,
  onBlur,
  height = 64,
  labelFontSize = 16,
  fontSize = 24,
  fontWeight = '500',
  fontFamily = 'JioType-Medium',
  type,
  ...props
}: any) => {
  const [showError, setShowError] = useState(false)
  const [isFocused, setFocused] = useState(false)
  const [isPressed, setPressed] = useState(false)
  const errorTimerRef = useRef<any>(0)
  const textInputRef = useRef<RNTextInput>(null)
  const refUsed = innerRef ?? textInputRef
  const onChangeText = (val) => {
    if (type === 'NUM_ONLY') {
      val = val.replace(/[^0-9.]/g, '')
      // collapse to a single dot (keep the first one)
      val = val.replace(/(\..*)\./g, '$1')
    } else if (type === 'NAME') {
      val = val.replace(/[^a-zA-Z ]/g, '')
    }
    if (fieldName && setFieldValue) {
      setFieldValue(fieldName, val)
    }
  }
  const onPress = () => {
    if (refUsed.current) {
      refUsed.current.focus()
    }
  }
  const onInternalFocus = () => {
    clearTimeout(errorTimerRef.current)
    setShowError(false)
    // setPressed(false)
    setFocused(true)
    if (onFocus) {
      onFocus()
    }
  }
  const onInternalBlur = () => {
    setFocused(false)
    if (type === 'NUM_ONLY' && fieldName && setFieldValue) {
      // remove a trailing dot so the dot is always followed by a number
      setFieldValue(fieldName, props.value.replace(/\.$/, ''))
    }
    if (onBlur) {
      onBlur()
    }
  }

  const isError = !isFocused && touched && !!error && !isPressed
  useEffect(() => {
    if (isError) {
      errorTimerRef.current = setTimeout(() => {
        setShowError(true)
      }, 500)
    } else {
      clearTimeout(errorTimerRef.current)
      setShowError(false)
    }
  }, [isError])

  return (
    <Box>
      <Box position={'absolute'} zIndex={1} top={-12} bg={'WHITE'} left={16} h={24} ph={3}>
        <Text
          title={label}
          fontSize={labelFontSize}
          fontFamily={'JioType-Medium'}
          lineHeight={24}
          color={Colors.BLACK_14 as ColorOptions}
        />
      </Box>
      <Box
        h={height}
        borderWidth={1}
        ph={16}
        borderRadius={8}
        justify={'center'}
        borderColor={
          showError
            ? (Colors.GREEN_ERROR_BG as ColorOptions)
            : isFocused
            ? Colors.PRIMARY
            : props.borderColor ?? 'BLACK'
        }>
        <TextInput
          onChangeText={onChangeText}
          minHeight={56}
          rightComponent={rightComponent}
          leftComponent={leftComponent}
          showBottomLine={false}
          fontFamily={fontFamily}
          fontWeight={fontWeight}
          fontSize={fontSize}
          color={Colors.BLACK_14 as ColorOptions}
          maxLength={maxLength}
          touched={true}
          onPress={onPress}
          onPressIn={() => {
            setPressed(true)
          }}
          onPressOut={() => {
            setPressed(false)
          }}
          onSubmitEditing={onInternalBlur}
          onFocus={onInternalFocus}
          onBlur={onInternalBlur}
          innerRef={refUsed}
          placeholderTextColor={props?.placeholderTextColor ?? (convertHexToRGBA(Colors.BLACK_14, 50) as ColorOptions)}
          returnKeyType="done"
          {...props}
          error={undefined}
        />
      </Box>
      {showError && (
        <Box pt={12} flexDirection={'row'} align={'flex-start'} justify="flex-start">
          <Box marginTop={1}>
            <SvgImage imageName="WarningIconError" color={Colors.GREEN_ERROR_BG} />
          </Box>
          <Spacer direction={'horizontal'} size={4} />
          <Box flexWrap={'wrap'} align="flex-start" f={1}>
            <Text
              testID={'textInputErrorId'}
              color={Colors.GREEN_ERROR_BG as ColorOptions}
              fontFamily={'JioType-Medium'}
              fontSize={12}
              lineHeight={16}
              letterSpacing={-0.06}>
              {error}
            </Text>
          </Box>
        </Box>
      )}
    </Box>
  )
}
